import { render, staticRenderFns } from "./TheHowItWorksLayout.vue?vue&type=template&id=de2b329e&scoped=true&"
import script from "./TheHowItWorksLayout.vue?vue&type=script&lang=js&"
export * from "./TheHowItWorksLayout.vue?vue&type=script&lang=js&"
import style0 from "./TheHowItWorksLayout.vue?vue&type=style&index=0&id=de2b329e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de2b329e",
  null
  
)

export default component.exports